/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon16Regular = forwardRef('NumberCircle07Icon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.762 4.123H5.207v1.232h3.872c-.69.96-1.29 2.017-1.804 3.168-.513 1.151-.843 2.277-.99 3.377h1.639a13.62 13.62 0 0 1 1.034-3.597c.52-1.188 1.122-2.211 1.804-3.069V4.123Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
